import type { Driver, Tag, TagToCreate } from '../../../../../types';
import { useCallback } from 'react';
import {
    DriverMultiSelectAddDialogBody,
    type DriverMultiSelectAddDialogBodyOwnProps,
} from '../components/DriverMultiSelectAddDialogBody';
import { getAllTagsInAccount } from '../../../../Drivers.selectors';
import { getDriversRtk } from '../../../appSlice';
import { useAppDispatch, useAppSelector } from '../../../../../configuration/setup/hooks';
import { setMultiSelectTagsToCreate, setMultiSelectTagToAdd } from '../../sidebar/tabs/groups/groupSlice';

export interface DriverMultiSelectAddDialogBodyPropertiesFromState {
    allTagsInAccount: Tag[];
    drivers: Driver[];
}

export interface DriverMultiSelectAddDialogBodyPropertiesFromDispatch {
    setTagsToAdd: (tag: Tag[]) => void;
    setTagsToCreate: (tagToCreate: TagToCreate[]) => void;
}

export const DriverMultiSelectAddDialogBodyContainer = (props: DriverMultiSelectAddDialogBodyOwnProps) => {
    const dispatch = useAppDispatch();
    const allTagsInAccount = useAppSelector(getAllTagsInAccount);
    const drivers = useAppSelector(getDriversRtk);
    const setTagsToAdd = useCallback((tags: Tag[]) => dispatch(setMultiSelectTagToAdd(tags)), [dispatch]);
    const setTagsToCreate = useCallback(
        (tagsToCreate: TagToCreate[]) => dispatch(setMultiSelectTagsToCreate(tagsToCreate)),
        [dispatch]
    );

    return (
        <DriverMultiSelectAddDialogBody
            {...props}
            allTagsInAccount={allTagsInAccount}
            drivers={drivers}
            setTagsToAdd={setTagsToAdd}
            setTagsToCreate={setTagsToCreate}
        />
    );
};
